import { View, Platform } from "react-native";
import { EMBER } from "../../../onboarding/theme";
import { withAlpha } from "@louise/theme/tokens";

export default function EmberBullet({
  color = EMBER.colors.warm,
}: {
  color?: string;
}) {
  return (
    <View
      style={{
        width: 6,
        height: 6,
        borderRadius: 3,
        marginTop: 7,
        flexShrink: 0,
        backgroundColor: color,
        ...(Platform.OS === "web" && {
          boxShadow: `0 0 8px ${withAlpha(color, 0.4)}`,
        }),
      }}
    />
  );
}
